module.exports = "<app-route-edit-areas route=$ctrl.route on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)></app-route-edit-areas> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/areas/template.html
// module id = 463
// module chunks = 0